import { Lightbulb } from "lucide-react";

export const ABOUT_LINES = [
  "This is not a school learning app. It's for information and fun: answering questions and finding out that little bit more.",
  "Three AIs work together to give you the right answer.",
  "Kids are inquisitive, so let the AIs answer their questions and debate with them.",
];

export const AboutWhat = ({ compact = false, testid = "about-what" }) => (
  <div data-testid={testid} className={`what-about ${compact ? "is-compact" : ""}`}>
    <p className="flex items-center gap-2 font-mono text-[11px] uppercase tracking-[0.18em] text-[#FBBF24]">
      <Lightbulb size={13} /> What is WHAT?
    </p>
    <div className="mt-2 space-y-1.5 text-sm text-slate-300 leading-relaxed">
      {ABOUT_LINES.map((l) => <p key={l}>{l}</p>)}
    </div>
    <p data-testid={`${testid}-tagline`} className="mt-3 font-display text-base font-semibold text-white">Who knows, we might even learn something.</p>
  </div>
);
